/**
 * Project Andromeda
 * Denis Callinan
 * May 14th, 2020
 * Navbar.js - React Component for the Navbar for the website
 */

import React from 'react';

// CSS
import "./Navbar.css"

// Media
import logo from "../../img/logo.png"
import menu from "../../img/menu.png"

class Tab extends React.Component {
  handleClick() {
    const element = document.getElementById(this.props.target);
    const y = element.getBoundingClientRect().top+ window.pageYOffset - 80;
    window.scrollTo({top: y, behavior: 'smooth'});
  }

  render() {
    return(
      <button className = {this.props.className} id = {this.props.id} onClick = {this.handleClick.bind(this)}>{this.props.title}</button>
    );
  }
}

function MobileMenu(props) {
  return(
    <div className = "menu" id = {props.id}>
        <div />
        <Tab className = "mTab" title = "ABOUT ME" target = "page-A"/>
        <Tab className = "mTab" title = "EDUCATION" target = "page-B"/>
        <Tab className = "mTab" title = "EXPERIENCE" target = "page-C"/>
        <Tab className = "mTab" title = "PORTFOLIO" target = "page-D"/>
        <Tab className = "mTab" title = "CONTACT" target = "contact"/>
    </div>
  )
}

export default class TabBar extends React.Component {
  handleClick() {
    window.scrollTo({top: 0, behavior: 'smooth'});
  }

  render() {
    const { windowWidth } = this.props.state;

    var mMenu;
    if (this.props.state.mWindowEnabled) {
      mMenu = <MobileMenu id = "menu_selected" height = {this.props.state.windowHeight}/>
    } else {
      mMenu = <MobileMenu id = "menu_deselected" height = {this.props.state.windowHeight}/>; 
    }
    var factor = 0.85;

    var divStyle = {
      background: 'rgba(45,49,66,' + (this.props.state.scrollPos/(factor*this.props.state.windowHeight)) + ')',
      boxShadow: '0px 4px rgba(22,26,43,' + (this.props.state.scrollPos/(factor*this.props.state.windowHeight)) + ')'
    }

    if (windowWidth > 950) {
      return(
        <div style = {divStyle} className = "tabBar">
          <input type="image" className = "logo" src = {logo}  onClick = {this.handleClick.bind(this)} alt = "drcall"/>
          <div id="gap"></div>
          <Tab className = "tab" id = {this.props.state.scrollPos > (factor*this.props.state.windowHeight) ? "about" : null} title = "ABOUT ME" target = "page-A"/>
          <Tab className = "tab" id = {this.props.state.scrollPos > (factor*this.props.state.windowHeight) ? "edu" : null} title = "EDUCATION" target = "page-B"/>
          <Tab className = "tab" id = {this.props.state.scrollPos > (factor*this.props.state.windowHeight) ? "exp" : null} title = "EXPERIENCE" target = "page-C"/>
          <Tab className = "tab" id = {this.props.state.scrollPos > (factor*this.props.state.windowHeight) ? "port" : null} title = "PORTFOLIO" target = "page-D"/>
          <Tab className = "rTab" title = "CONTACT" scrollTarget = {7.5*this.props.state.windowHeight} target = "contact"/>
        </div>
      );
    } else {
      return(
        <div style = {divStyle} className = "tabBar">
          <input type="image" className = "mobileLogo" src = {logo} onClick = {this.handleClick.bind(this)} alt = "drcall"/>
          <div id="gap-mobile"></div>
          <input type="image" className = "mobileLogo" src = {menu}  alt = "menu" onClick = {this.props.handle}/>
          {mMenu}
        </div>
      );
    }
  }
}